<template>
    <div>
        <label :for="id" class="block text-sm font-medium text-gray-700">
            <slot></slot>
        </label>
        <select v-bind:value="value"
                v-on:input="$emit('input', $event.target.value)"
                :id="id"
                class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm rounded-md">
            <option v-if="placeholder" value=""> {{placeholder}}</option>
            <option v-for="(v,i) in values" :value="i">{{ v }}</option>
        </select>
    </div>
</template>

<script>
import uniqueId from "lodash/uniqueId";

export default {
    name: "Selection",

    props: {
        value: {},
        values: {},
        enables: {},
        placeholder: {}
    },

    data: () => ({
        id: uniqueId(),
    }),

}
</script>
